// src/guide/tickets/guide_commenter.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_commenter(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.tickets.commenter.commentaire.titre,
    translations.tickets.commenter.commentaire.texte,
    "#commentaire",
    "bottom"
  );

  if (document.getElementById("reponse_pre_faite")) {
    guide_tour_step(
      tour,
      translations,
      translations.tickets.commenter.reponse_pre_faite.titre,
      translations.tickets.commenter.reponse_pre_faite.texte,
      "#reponse_pre_faite",
      "top"
    );
  }

  guide_tour_step(
    tour,
    translations,
    translations.tickets.commenter.pieces_jointes.titre,
    translations.tickets.commenter.pieces_jointes.texte,
    "#file",
    "top"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.tickets.commenter.valider_commenter.titre,
    translations.tickets.commenter.valider_commenter.texte,
    "#click",
    "top"
  );

  tour.start();
}
